import { IStore } from "~/state/store";
import { IConfig } from "~/config";

export let store: IStore = null;
export let CONFIG: IConfig = null;
export let Scene: any = null;
// eslint-disable-next-line id-length
export let _: any = null;
export let Notifications: any = null;

export function setGlobals(global: {
	store: IStore;
	CONFIG: IConfig;
	Scene: any;
	_: any;
	Notifications: any;
}) {
	store = global.store;
	CONFIG = global.CONFIG;
	Scene = global.Scene;
	_ = global._;
	Notifications = global.Notifications;
}
